import { ShieldAlert } from "lucide-react";

interface KMinGuardProps {
  meetsKMin: boolean;
  kMin: number;
  respondentCount: number;
  children: React.ReactNode;
}

export function KMinGuard({ meetsKMin, kMin, respondentCount, children }: KMinGuardProps) {
  if (meetsKMin) return <>{children}</>;

  return (
    <div className="flex items-center gap-2 text-muted-foreground text-sm py-1">
      <ShieldAlert className="h-4 w-4 text-amber-500 shrink-0" />
      <span>Dados protegidos (mínimo {kMin} respondentes, atual: {respondentCount})</span>
    </div>
  );
}

export function KMinBanner({ kMin }: { kMin: number }) {
  return (
    <div className="flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-200">
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span>
        Dados com menos de <strong>{kMin} respondentes</strong> são protegidos para garantir anonimato (kMin).
      </span>
    </div>
  );
}
